<template>
  <div class="pad-bot30 backwihte width100 margin-auto">
    <div class="stewardbox">
      <div class="textalign-left pad-bot10 f16">专利申请</div>
      <!-- <p class="stewardtitle">专利申请</p> -->
      <div class="patentapp">
        <p class="width90 margin-auto margin-top10 pad-top20">专利类型</p>
        <el-radio-group
          v-model="radio"
          @change="onchange"
          class="radiogroup"
          v-for="(item, index) in table"
          :key="index"
        >
          <el-radio :label="index">{{ item.name }}</el-radio>
        </el-radio-group>
        <div class="inputbox">
          <p class="margin-top10">专利名称</p>
          <el-input
            placeholder="请输入专利名称"
            v-model="patent"
            clearable
            class="input"
          >
          </el-input>

          <div>
            <p class="margin-top10">交底材料</p>
            <el-input
              placeholder="专利交底材料仅支持jpg,png,gif,doc,docx,zip,rar格式"
              v-model="filename"
              class="input"
              maxlength="0"
            >
              <template slot="append">
                <el-upload
                  class="avatar-uploader"
                  :action="Apisrc"
                  name="images"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :on-error="handleerror"
                  :data="user"
                  :headers="head"
                >
                  上传
                </el-upload></template
              >
            </el-input>
          </div>
          <div>
            <p class="margin-top10">计划申请时间</p>
            <el-date-picker
              class="input datepic"
              v-model="apply_date"
              type="date"
              placeholder="计划申请时间"
              value-format="yyyy-MM-dd"
              :editable="false"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>
          <div>
            <p class="margin-top10">联系人</p>
            <el-input
              placeholder="请输入联系人"
              v-model="contact"
              clearable
              class="input"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="margin-top20 width90 margin-auto flex-betweenNowrapAlign">
        <p class="dolwed">点此下载专利交底材料模板</p>
        <div>
          <el-button @click="dialognull()">取 消</el-button>
          <el-button type="primary" @click="addpant()">立即申请</el-button>
        </div>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { entpatentapplysave } from "@/api/newhead/newhead.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      radio: "",
      table: [
        { name: "发明专利", ite: 1 },
        { name: "实用新型", ite: 2 },
        { name: "外观专利", ite: 3 },
      ],
      input: "",
      input2: "",
      Apisrc: "",
      user: {
        // images: "",
      },
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      patent_type: "",
      patent: "",
      files: "",
      apply_date: "",
      contact: "",
      filename: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  methods: {
    // 上传
    handleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        this.files = response.data.url;
        this.filename = file[0].name;
      }
    },
    handleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      this.dialogVisiblenull = true;
      this.errormessage = myError.msg;
    },
    onchange(val) {
      this.patent_type = val + 1;
    },
    // 专利申请
    addpant() {
      if (this.patent_type == "") {
        this.dialogVisiblenull = true;
        this.errormessage = "请选择专利类型";
      } else if (this.apply_date == "") {
        this.dialogVisiblenull = true;
        this.errormessage = "请选择申请时间";
      } else {
        entpatentapplysave({
          patent_type: this.patent_type,
          patent: this.patent,
          file: this.files,
          apply_date: this.apply_date,
          contact: this.contact,
        }).then((res) => {
          if (res.data.code == 200) {
            window.sessionStorage.setItem("onlineactiveName", "second");
            BUS.$emit("Applyfor", "yess");
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    dialognull() {
      BUS.$emit("Applyfor", "yesno");
    },
  },
  components: {},
  created() {
    this.Apisrc = window.g.ApiUrl + "/oss_form";
  },
  updated() {},
};
</script>

<style scoped>
.stewardbox {
  width: 95%;
  margin: auto;
  padding: 20px 0 0 0;
}
.stewardtitle {
  font-size: 14px;
  color: #0039bf;
  text-align: center;
}
.patentapp {
  width: 100%;
  min-height: 100px;
  background: #f6f7fb;
  margin: 10px 0 0 0;
  padding: 0 0 20px 0;
  border-radius: 3px;
}
.radiogroup {
  padding: 20px 0 10px 30px;
}
.inputbox {
  width: 90%;
  margin: auto;
}
.dolwed {
  width: 40%;
  font-size: 14px;
  color: #52c5cb;
  line-height: 20px;
}
.input {
  margin: 10px 0 0 0;
}
.datepic {
  width: 100%;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>
